import { Alert } from 'antd';
import React, { useContext, useEffect } from 'react';

import useDispatchSetterStore from '../../hooks/useDispatchSetterStore';
import useDynamicSelector from '../../hooks/useDynamicSelector';
import { SmxPropsContext } from '../../providers/propsProvider';
import { getSetterListItem, IListItemState } from '../../store/slices/listItemSlice';

const ListItem = () => {
    const context = useContext(SmxPropsContext);

    const setterListItem = useDispatchSetterStore<IListItemState>(
        getSetterListItem(context.nameList + context.prefixStore),
    );
    const messageError = useDynamicSelector('listItem', 'messageError');

    useEffect(() => {
        if (messageError) {
            setTimeout(() => {
                setterListItem({ messageError: '' });
            }, 2000);
        }
    }, [messageError]);

    return <>{messageError && <Alert message={messageError} type="error" />}</>;
};

export default ListItem;
